import { useCallback } from 'react';
import React from 'react';
import { useWindowManager } from '../components/Window/WindowManager';
import { DocumentPreviewWindow } from '../components/DocumentPreviewModal';

export interface DocumentPreviewParams {
    documentUrl: string;
    contratoId: number;
    formComponent: string;
    title?: string;
}

export const useDocumentPreviewHandler = () => {
    const windowManager = useWindowManager();

    const openDocumentPreview = useCallback((params: DocumentPreviewParams) => {
        let windowId: string;
        const Component = () => (
            <DocumentPreviewWindow
                contratoId={params.contratoId}
                documentUrl={params.documentUrl}
                formComponent={params.formComponent}
                triggerClose={() => windowManager.closeWindow(windowId)}
            />
        );
        windowId = windowManager.openWindow({
            title: params.title || 'Preview de Documento',
            component: Component,
            size: { width: window.innerWidth - 40, height: window.innerHeight - 100 },
            loading: false,
            data: null,
        });
    }, [windowManager]);

    return { openDocumentPreview };
};

export type { DocumentPreviewParams as DocumentPreviewParamsType };
